import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitovadodaracab() {



const cardData = {
  keyword: "Mumbai to Vadodara Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Vadodara cab services for travelers seeking a smooth and convenient journey between Maharashtra and Gujarat. Whether you are traveling for business, family visits, weekend trips, or group tours, our cab service ensures a safe and hassle-free ride with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Vadodara cab services.",

topPlaces: [
  {
    title: "Laxmi Vilas Palace",
    description:
      "Laxmi Vilas Palace is an architectural marvel and the residence of the royal family of Vadodara. Visitors can explore the grand halls, museum, and beautifully landscaped gardens. Traveling by cab ensures a comfortable journey from Mumbai and allows ample time to enjoy the rich heritage and architecture of the palace."
  },
  {
    title: "Sayaji Baug (Kamati Baug)",
    description:
      "Sayaji Baug is a sprawling park with a zoo, planetarium, museum, and boating facilities. Visitors can enjoy leisure walks, family activities, and recreational experiences. A cab ride provides convenient access, enabling tourists to plan a full day exploring the park and nearby attractions without transport worries."
  },
  {
    title: "Baroda Museum & Picture Gallery",
    description:
      "The Baroda Museum and Picture Gallery houses an impressive collection of art, artifacts, and natural history exhibits. Visitors can explore cultural heritage, take photographs, and learn about the region’s history. Traveling by cab ensures hassle-free access and flexible time for museum visits along with other sightseeing spots."
  },
  {
    title: "Kirti Mandir",
    description:
      "Kirti Mandir is a memorial dedicated to the Gaekwad rulers, featuring intricate architecture and historical significance. Visitors can explore the mandir, gardens, and enjoy peaceful surroundings. A cab service provides comfortable travel from Mumbai, making it easy to include this heritage site in a sightseeing itinerary."
  },
  {
    title: "Sur Sagar Lake",
    description:
      "Sur Sagar Lake is a scenic lake in the heart of Vadodara, ideal for leisurely walks, photography, and relaxation. Visitors can enjoy the serene environment and take boat rides in some areas. Traveling by cab ensures easy access and the flexibility to combine the lake visit with other city attractions."
  },
  {
    title: "EME Temple",
    description:
      "EME Temple is a unique temple built by the Indian Army, dedicated to Lord Dakshinamurthy, and known for its modern architecture. Visitors can admire the design, perform rituals, and enjoy the peaceful ambiance. A cab ride provides hassle-free travel from Mumbai, allowing inclusion in a full day of sightseeing."
  },
  {
    title: "Ajwa Water Park",
    description:
      "Ajwa Water Park offers family-friendly water rides, pools, and recreational activities. Visitors can enjoy a fun day out with children and friends. Traveling by cab ensures convenient transport, allowing tourists to plan leisure and sightseeing seamlessly."
  },
  {
    title: "Hathee Singh Jain Temple",
    description:
      "Hathee Singh Jain Temple is an ornate Jain temple with intricate carvings and religious significance. Visitors can explore the temple, perform rituals, and capture photography. A cab service provides comfortable travel from Mumbai, making it easier to include this spiritual site in the itinerary."
  },
  {
    title: "Makarpura Palace",
    description:
      "Makarpura Palace is a historic royal palace featuring stunning architecture, gardens, and heritage interiors. Visitors can explore the palace grounds and take photographs. Traveling by cab ensures easy access and flexible time to explore Vadodara’s royal heritage."
  },
  {
    title: "Inorbit Mall & Food Courts",
    description:
      "Inorbit Mall in Vadodara offers shopping, dining, and entertainment options including cinemas and cafes. Visitors can enjoy local and international brands, food, and leisure activities. A cab ride provides hassle-free access, allowing tourists to combine shopping with cultural and sightseeing experiences efficiently."
  }
],




services: [
{
name: "Mumbai to Vadodara Cab",
description: "Mumbai to Vadodara cab service offers comfortable and reliable intercity transportation between Maharashtra and Gujarat. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth long-distance highway travel. Professional drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. Ideal for business travelers, family trips, and corporate travel needs. Spacious seating and air-conditioned interiors provide relaxed travel during the journey. Flexible one-way and round-trip booking options allow convenient travel planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Vadodara Taxi",
description: "Mumbai to Vadodara taxi service provides dependable road transportation for passengers traveling between the two cities. Comfortable AC vehicles ensure pleasant travel along well-connected highways. Experienced drivers handle long-distance routes with safety and efficiency. Pickup services are available from homes, offices, hotels, and Mumbai airport terminals. Ideal for corporate travel, tourism, and family visits. Clean interiors and spacious seating provide comfortable journeys. Flexible departure schedules allow passengers to plan trips conveniently. Reliable taxi services ensure smooth and safe intercity travel."
},
{
name: "Mumbai to Vadodara Cab Service",
description: "Mumbai to Vadodara cab service offers reliable transportation for long-distance travelers. Our well-maintained AC vehicles ensure comfortable and smooth highway travel. Professional drivers ensure safe driving and timely arrival at the destination. Pickup is available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, family journeys, and personal trips. Spacious seating ensures comfort throughout extended journeys. Flexible booking options allow passengers to schedule trips easily. Transparent pricing ensures dependable cab service."
},
{
name: "Mumbai to Vadodara Taxi Service",
description: "Mumbai to Vadodara taxi service offers convenient travel between two important commercial cities. Our fleet includes AC sedans and SUVs designed for long-distance journeys. Skilled drivers ensure safe highway travel and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business meetings, tourism, and family visits. Spacious interiors provide comfortable seating for passengers. Flexible travel schedules allow convenient trip planning. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Vadodara",
description: "Cab from Mumbai to Vadodara provides private and comfortable transportation for passengers traveling interstate. Our AC vehicles ensure smooth and relaxed highway journeys. Professional drivers ensure safe driving and reliable service throughout the trip. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family travel, business visits, and personal trips. Spacious seating ensures comfortable travel for long hours. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Vadodara",
description: "Taxi from Mumbai to Vadodara offers dependable road transportation for travelers seeking comfortable journeys. AC vehicles provide pleasant travel conditions across the long highway route. Experienced drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and Mumbai airport terminals. Ideal for business travelers, families, and tourists. Clean interiors and spacious seating ensure passenger comfort. Flexible scheduling allows easy travel planning. Professional taxi services ensure reliable intercity transportation."
},
{
name: "Mumbai to Vadodara Cab Booking",
description: "Mumbai to Vadodara cab booking allows passengers to reserve vehicles easily for intercity travel. Online and phone booking options provide quick confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family trips, business travel, and tourism. Flexible one-way and round-trip booking options are available. Reliable booking services ensure hassle-free travel."
},
{
name: "Mumbai to Vadodara Taxi Booking Online",
description: "Mumbai to Vadodara taxi booking online provides quick and convenient reservations for long-distance travel. Instant booking confirmation allows travelers to schedule trips easily. Comfortable AC vehicles ensure relaxed highway journeys. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travelers and families. Flexible travel timing allows convenient trip scheduling. Reliable online booking ensures smooth taxi reservations."
},
{
name: "Mumbai to Vadodara Cab Price",
description: "Mumbai to Vadodara cab price offers transparent and affordable travel options for passengers planning interstate journeys. Clear pricing helps travelers understand the total trip cost before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway driving and timely arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Vadodara Taxi Fare",
description: "Mumbai to Vadodara taxi fare is calculated with transparent per-kilometer pricing to provide clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth highway travel between the two cities. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel and family trips. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Vadodara One Way Cab",
description: "Mumbai to Vadodara one way cab service is ideal for travelers who require drop service without paying return charges. This option helps reduce travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance highway travel. Professional drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel and personal visits. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
}
],

tableData: [
["Mumbai to Vadodara Cab","Mumbai to Vadodara Taxi"],
["Mumbai to Vadodara Cab Service","Mumbai to Vadodara Taxi Service"],
["Cab from Mumbai to Vadodara","Taxi from Mumbai to Vadodara"],
["Mumbai to Vadodara Cab Booking","Mumbai to Vadodara Taxi Booking Online"],
["Mumbai to Vadodara Cab Price","Mumbai to Vadodara Taxi Fare"],
["Mumbai to Vadodara One Way Cab","Best Cab Mumbai to Vadodara"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Vadodara highway route via NH48. They understand highway traffic, toll routes, and safe driving practices, ensuring a smooth and stress-free intercity journey between Maharashtra and Gujarat."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Vadodara cab bookings. We clearly explain per-kilometer charges, toll costs, and travel packages before booking so customers never face hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel early morning, late night, or overnight, Omshree Cabs offers 24/7 cab booking and customer support for your Mumbai to Vadodara trip."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are cleaned and sanitized regularly. This ensures a comfortable ride for long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel plans including one-way cabs, round-trip journeys, and multi-day travel options so passengers can customize their travel schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for business travelers, families, and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai so your journey to Vadodara begins smoothly and on time."
  },
  {
    WhyChooseheading: "Reliable Intercity Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for Mumbai to Vadodara cab services. Our punctual drivers, well-maintained vehicles, and professional service ensure a safe and pleasant travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Vadodara by cab?", answer: "The distance from Mumbai to Vadodara is approximately 420 km and the journey usually takes around 7–8 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Vadodara cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Vadodara." },
  { question: "Which vehicles are available for Mumbai to Vadodara travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport or any location in Mumbai for Vadodara cab bookings." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Do you provide night travel services?", answer: "Yes, Omshree Cabs provides safe overnight travel options with experienced drivers." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, festivals, and peak travel seasons." },
  { question: "Do you provide corporate cab services to Vadodara?", answer: "Yes, Omshree Cabs provides corporate and business travel cab services from Mumbai to Vadodara." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Desai",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Vadodara business trip. The driver was punctual and the car was very comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Bhavna Shah",
    feedback:
      "Our family trip from Mumbai to Vadodara with Omshree Cabs was excellent. Clean vehicle, smooth driving, and transparent pricing made the journey stress-free.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Vadodara Cab",
  "description": "Book Mumbai to Vadodara Cab with Omshree Cab for safe and comfortable outstation travel. Reliable taxi service from Mumbai to Vadodara with options for one-way trips. Affordable fares, easy online cab booking, and trusted cab service for your Vadodara journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2300"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Mumbai to Vadodara Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Vadodara Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Vadodara with one-way options. Affordable fares and easy online cab booking for your Vadodara trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitovadodaracab;